import React from 'react';
import '../TeleCalling.css';
import history from '../../../Utility/history';


const EntityLinkCell = ({ id, path, onNavigate }) => (
    <span
        onClick={() => {
            history.push(`${path}/${id}`);
            onNavigate && onNavigate();
        }}
        className="tc-entity-link"
    >
        {id}
    </span>
);

export default EntityLinkCell;
